import * as React from 'react';

import './DateBill.example.scss';

interface DateBillExampleProps {
    numericalRange: number;
    originValue: number;
    originDay?: string;
    originLabel: string;
    referenceValue: number;
    referenceDay?: string;
    referenceFromToday?: boolean;
    referenceLabel: string;
}

class DateBillExample extends React.Component {
    props: DateBillExampleProps

    renderOrigin() {
        const percentOf = Math.round((this.props.numericalRange - this.props.originValue) * 100 / this.props.numericalRange);
        const styleForLabel = {
            minWidth: `45px`,
        }
        const styleForOrigin = {
            width: `${percentOf}%`,
            left: `${100 - percentOf}%`
        }
        return (
            <div className="dateBillOrigin" style={styleForOrigin}>
                <p className="dateBillLabel" style={styleForLabel}>
                    {this.props.originLabel}
                </p>
            </div>
        )
    }

    renderReference() {
        const percentOf = Math.round(this.props.referenceValue * 100 / this.props.numericalRange);
        const originPercentOf = Math.round((this.props.numericalRange - this.props.originValue) * 100 / this.props.numericalRange);
        let refClass = `dateBillReference`;
        const styleForLabel = {
            minWidth: `100px`
        }
        const styleForReference:{width:string, right?:string} = {
            width: `${percentOf}%`,
        }
        if (!!this.props.referenceFromToday) {
            styleForReference['right'] = `${originPercentOf}%`;
            styleForReference['width'] = `${90 - originPercentOf}%`;
            refClass += ' fromRight';
        }
        return (
            <div className={refClass} style={styleForReference}>
                <p className="dateBillLabel" style={styleForLabel}>
                    {this.props.referenceLabel}
                </p>
                {
                    !!this.props.referenceDay ?

                        <p className="dayForReference">
                            {this.props.referenceDay}
                        </p>
                        : ''
                }
            </div>
        )
    }

    render() {
        const dateClass = `dateBillExample${this.props.originValue === this.props.referenceValue ? ' overlaps' : ''}`
        return (
            <div className={dateClass}>
                {this.renderReference()}
                {this.renderOrigin()}
            </div>
        )
    }
}

export default DateBillExample;